<script lang="ts">
  import { userStore } from '../stores/auth.store';
  import { replace } from 'svelte-spa-router';
  import { onMount } from 'svelte';

  let redirecting = true;

  // Handle automatic redirection to appropriate dashboard
  onMount(() => {
    if ($userStore?.user_role?.name) {
      const role = $userStore.user_role.name;
      console.log("role", role);
      // Small delay to show loading state
        // Redirect to appropriate dashboard based on role
        switch (role) {
          case 'Charity':
            replace('/charity-dashboard');
            break;
          case 'User': // Employee role
            replace('/dashboard');
            break;
          case 'Employer':
            replace('/employer-dashboard');
            break;
          case 'Admin':
            replace('/admin-dashboard');
            break;
          default:
            replace('/admin-dashboard');
            break;
        }
    } else {
      // If user doesn't have a role yet, wait for userStore to update
      const unsubscribe = userStore.subscribe((user) => {
        if (user?.user_role?.name) {
          const role = user.user_role.name;
          console.log("role", role);
            switch (role) {
              case 'Charity':
                replace('/charity-dashboard');
                break;
              case 'User': // Employee role
                replace('/dashboard');
                break;
              case 'Employer':
                replace('/employer-dashboard');
                break;
              case 'Admin':
                replace('/admin-dashboard');
                break;
              default:
                replace('/admin-dashboard');
                break;
            }
          
          unsubscribe();
        } else {
          // If after 3 seconds we still don't have a role, show 404
          setTimeout(() => {
            redirecting = false;
          }, 100);
        }
      });
    }
  });
</script>

{#if redirecting}
  <div class="redirect-container">
    <div class="redirect-content">
      <div class="loading-spinner"></div>
      <h3>Welcome back!</h3>
      <p>Taking you to your dashboard...</p>
    </div>
  </div>
{:else}
  <div class="not-found-container">
    <div class="not-found-content">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for does not exist or has been moved.</p>
      <button on:click={() => replace('/')}>Go Home</button>
    </div>
  </div>
{/if}

<style>
  .redirect-container,
  .not-found-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  
  .redirect-content,
  .not-found-content {
    text-align: center;
    padding: 2rem;
    max-width: 400px;
    width: 100%;
  }
  
  .loading-spinner {
    width: 3rem;
    height: 3rem;
    border: 4px solid #f3f4f6;
    border-top: 4px solid var(--color-primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 1.5rem;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--color-text-dark);
  }
  
  p {
    margin: 0;
    font-size: 1rem;
    color: #6B7280;
  }

  /* 404 Styles */
  h1 {
    color: var(--color-text-dark);
    font-size: 8rem;
    font-weight: 700;
    margin: 0;
    line-height: 1;
  }

  h2 {
    color: var(--color-text-dark);
    font-size: 2rem;
    font-weight: 600;
    margin: 1rem 0;
  }

  .not-found-content p {
    margin: 1.5rem 0;
    font-size: 1.125rem;
  }

  button {
    background-color: var(--color-primary);
    color: var(--color-text-dark);
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: var(--border-radius-button);
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color 0.2s;
  }

  button:hover {
    background-color: var(--color-primary-hover);
  }

  @media (max-width: 640px) {
    h1 {
      font-size: 6rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .not-found-content p {
      font-size: 1rem;
    }
  }
</style> 